/**
 * Editorial overlay: click MENU to open; hover parent items for inline submenu.
 * Only Clothing swaps the right-side image.
 */
(function () {
  function initOverlayNav() {
    const overlay = document.querySelector('[data-overlay-nav]');
    if (!overlay) return;

    const overlayEl = overlay;
    const triggers = Array.from(document.querySelectorAll('[data-overlay-trigger], [data-overlay-open]'));
    const closeBtn = overlay.querySelector('[data-overlay-close]');
    const parentItems = Array.from(overlay.querySelectorAll('.overlay-nav__item--has-children'));
    const defaultImage = overlay.querySelector('.overlay-nav__image-layer--default');
    const clothingImage = overlay.querySelector('[data-submenu-image="clothing"]');

    let lastTrigger = null;

    function setExpanded(expanded) {
      triggers.forEach((t) => t.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
    }

    function showDefaultImage() {
      overlayEl.classList.remove('is-clothing-image');
      defaultImage?.classList.add('is-active');
      clothingImage?.classList.remove('is-active');
    }

    function showClothingImage() {
      if (!clothingImage) return;
      overlayEl.classList.add('is-clothing-image');
      defaultImage?.classList.remove('is-active');
      clothingImage.classList.add('is-active');
    }

    function resetSubmenus() {
      parentItems.forEach((item) => item.classList.remove('is-active'));
      showDefaultImage();
    }

    function openOverlay(invokedBy) {
      const filterOverlay = document.querySelector('[data-overlay-filters]');
      if (filterOverlay?.classList.contains('is-open')) {
        filterOverlay.classList.remove('is-open');
        filterOverlay.setAttribute('aria-hidden', 'true');
        document.querySelectorAll('[data-overlay-filter-trigger]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }
      const searchDropdown = document.querySelector('[data-search-dropdown]');
      if (searchDropdown?.classList.contains('is-open')) {
        searchDropdown.classList.remove('is-open');
        searchDropdown.setAttribute('aria-hidden', 'true');
        document.documentElement.removeAttribute('scroll-lock');
        document.querySelectorAll('[data-search-dropdown-trigger]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }
      lastTrigger = invokedBy || lastTrigger;
      overlayEl.classList.add('is-open');
      overlayEl.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');
      setExpanded(true);
      resetSubmenus();
      closeBtn?.focus();
    }

    function closeOverlay() {
      overlayEl.classList.remove('is-open', 'is-clothing-image');
      overlayEl.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('scroll-lock');
      setExpanded(false);
      resetSubmenus();
      lastTrigger?.focus();
    }

    triggers.forEach((t) => {
      t.addEventListener('click', (e) => {
        e.preventDefault();
        if (overlayEl.classList.contains('is-open')) closeOverlay();
        else openOverlay(t);
      });
    });

    closeBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      closeOverlay();
    });

    overlayEl.addEventListener('click', (e) => {
      if (e.target === overlayEl) closeOverlay();
    });

    parentItems.forEach((item) => {
      const switchesImage = item.querySelector('[data-overlay-switch-image]');

      item.addEventListener('mouseenter', () => {
        parentItems.forEach((el) => el.classList.remove('is-active'));
        item.classList.add('is-active');
        if (switchesImage) showClothingImage();
        else showDefaultImage();
      });

      item.addEventListener('mouseleave', (e) => {
        const related = e.relatedTarget;
        if (related instanceof Node && item.contains(related)) return;
        item.classList.remove('is-active');
        window.setTimeout(() => {
          if (!overlay.querySelector('.overlay-nav__item--has-children:hover')) {
            resetSubmenus();
          }
        }, 50);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (overlayEl.getAttribute('aria-hidden') === 'true') return;
      e.preventDefault();
      if (overlay.querySelector('.overlay-nav__item--has-children.is-active')) resetSubmenus();
      else closeOverlay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOverlayNav);
  } else {
    initOverlayNav();
  }
})();
